















import Vue, { PropType } from 'vue';
import SectionForm, {
  FormDataInterface,
} from '@/containers/cv-section-skill/form.vue';
import * as CvStore from '@/containers/cv/store';
import * as CvSectionSkillStoreEdit from '@/store/modules/cvSectionSkillEdit';
import { CvSectionSkill } from '@/../gen';
import { i18n, i18nHints } from '@/plugins/i18n';

export default Vue.extend({
  components: {
    SectionForm,
  },
  props: {
    section: {
      type: Object as PropType<CvSectionSkill>,
      required: true,
    },
  },
  methods: {
    async onSubmit({ title }: FormDataInterface) {
      const { cv_id, id } = this.section;
      await this.$store.dispatch(
        CvSectionSkillStoreEdit.UpdateCvSectionSkill.namespaced({
          params: {
            cv_id,
            id,
          },
          body: {
            title,
          },
        })
      );
      this.$notifySuccess(i18n.tc(i18nHints.common.notification.updated));
      // refresh sections
      this.$store.dispatch(CvStore.GetCvCvSections.namespaced({ cv_id }));
    },
    onCancel() {
      this.$backOrGoTo({ name: 'cv_edit_path' });
    },
    async onDelete() {
      const { cv_id, id } = this.section;
      await this.$store.dispatch(
        CvSectionSkillStoreEdit.DeleteCvSectionSkill.namespaced({
          params: {
            cv_id,
            id,
          },
        })
      );
      this.$notifySuccess(i18n.tc(i18nHints.common.notification.deleted));
      // refresh sections
      this.$store.dispatch(CvStore.GetCvCvSections.namespaced({ cv_id }));
      this.$router.push({ name: 'cv_edit_path' });
    },
  },
});
